import { z } from "zod";

export const suitabilitySchema = z.object({
  // Read-only fields (populated from inpData)
  dpInvType: z.string(),
  dpFinancialSituation: z.string(),
  dpInvTime: z.string(),
  dpRisktolerance: z.string(),
  dpRiskpreferenceAndInvestmentGoals: z.string(),
  dpEsgPreference: z.string(),
  dpInitStockPart: z.string(),
  dpFinStockPart: z.string(),
  dpSystemAdvice: z.string(),
  // Editable fields
  useInputFromCustomerAgreementInSuitabilityStatement: z.boolean(),
  dpAdvAdvice: z.string(),
  dpAdvAdviceESG: z.string(),
});

export type SuitabilityData = z.infer<typeof suitabilitySchema>;
